import React from "react";
import { Link } from "react-router-dom";
import styles from "./SchoolHomePage.module.css";

const SchoolHomePage = () => {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>PrepX Pathshala [School+Coaching] Model</h1>
          {/* New badge below heading */}
        <div className={styles.badge}>Biggest Revolution</div>
        <p className={styles.tagline}>
          <strong>One Campus. One Fee. Complete Education.</strong>
        </p>
        <p className={styles.revolution}>
          The <span className={styles.highlight}>most affordable combo - Your school is your coaching now.</span> – 
          first time in India!<br />
          <em>A true revolution in India's education ever. Now every students from rural to urban will prepare and study together and with most affordable fee. Guided by experts from <span className={styles.highlight}>Only IITs / NITs / IIITs and other top universities.</span> </em>
        </p>
        <div style={{ marginTop: '18px' }}>
          <Link
            to="/study-materials"
            state={{ returnSection: 'chapterwise', returnTab: 'chapterwise', returnHash: '#chapterwise-notes' }}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '12px 22px',
              borderRadius: '999px',
              background: '#021d6d',
              color: '#fff',
              textDecoration: 'none',
              fontWeight: 700,
            }}
          >
            Open School Chapterwise Notes
          </Link>
        </div>
      </header>

      <section className={styles.section}>
        <h2>About PrepX Pathshala [School+Coaching] Model Excellence</h2>
        <p>
          PrepX Pathshala is India’s first truly integrated CBSE school + coaching model in Delhi. 
          We combine regular CBSE schooling with world-class competitive exam coaching — all under one roof, during school hours.
        </p>
        <p>
          No more running from school to coaching centers. No more paying two sets of fees. At PrepX Pathshala, your child learns everything — from school syllabus to IIT-JEE, NEET, CUET, NDA, CA Foundation preparation — without extra stress.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Our Concept</h2>
        <ul>
          <li><strong>One Fee – Two Benefits:</strong> Parents pay once and get both school education and competitive exam preparation.</li>
          <li><strong>Time-Saving Integrated Timetable:</strong> Coaching is built into the daily school routine — no extra classes after hours.</li>
          <li><strong>Top Faculty:</strong> IIT/NIT graduates, doctors, and experienced CBSE board teachers teach in small batches.</li>
          <li><strong>Balanced Learning:</strong> Academics + sports + activities to keep students motivated and healthy.</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>Classes We Offer</h2>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Class Group</th>
              <th>Focus Area</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Class 6–8</td>
              <td>Olympiad & NTSE foundations + CBSE syllabus mastery</td>
            </tr>
            <tr>
              <td>Class 9–10</td>
              <td>Strong CBSE preparation + early competitive training</td>
            </tr>
            <tr>
              <td>Class 11–12</td>
              <td>CBSE syllabus + specialized competitive batch (IIT-JEE, NEET, or General)</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className={styles.section}>
        <h2>Specialized Batches for Class 11–12th</h2>
        <p>
        Students entering Class 11 can choose a specialized batch based on their competitive exam goals. If they aim for engineering, they can enroll in the <strong>IIT-JEE Batch</strong> focused on intensive preparation alongside the CBSE syllabus. Those targeting medical entrance exams can select the <strong>NEET Batch</strong>, which combines board studies with dedicated NEET coaching. For students planning other competitive exams or focusing mainly on board success, the <strong>General Batch</strong> provides balanced coaching tailored to their needs. This way, every student gets personalized guidance aligned with their ambitions — all within the same school environment.
        </p>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Batch Name</th>
              <th>Target Exam</th>
              <th>Subjects Covered</th>
              <th>Faculty Type</th>
              <th>Key Features</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>IIT-JEE Batch</td>
              <td>JEE Main & Advanced + CBSE Boards</td>
              <td>Physics, Chemistry, Mathematics + Board subjects</td>
              <td>IIT/NIT alumni, JEE experts</td>
              <td>Daily problem-solving, weekly JEE mock tests, advanced practice sheets</td>
            </tr>
            <tr>
              <td>NEET Batch</td>
              <td>NEET-UG + CBSE Boards</td>
              <td>Physics, Chemistry, Biology + Board subjects</td>
              <td>Doctors, NEET-focused faculty</td>
              <td>NCERT line-by-line teaching, bio-practical focus, NEET mock tests</td>
            </tr>
            <tr>
              <td>General Batch</td>
              <td>CBSE Boards + CUET / NDA / CA Foundation basics</td>
              <td>Subjects as per stream (Science/Commerce/Humanities)</td>
              <td>Experienced CBSE teachers</td>
              <td>Board scoring focus, aptitude training, career guidance</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className={styles.section}>
        <h2>Affordable Monthly Fee Structure</h2>
        <table className={styles.feeTable}>
          <thead>
            <tr>
              <th>Class Group</th>
              <th>School Academic Fee</th>
              <th>Coaching Fee</th>
              <th>Study Materials & Tests</th>
              <th>Activities & Labs</th>
              <th>Total Monthly Fee</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Class 6–8</td>
              <td>₹2,500</td>
              <td>₹1,875</td>
              <td>₹625</td>
              <td>₹313</td>
              <td><strong>₹5,313</strong></td>
            </tr>
            <tr>
              <td>Class 9–10</td>
              <td>₹3,125</td>
              <td>₹2,500</td>
              <td>₹938</td>
              <td>₹313</td>
              <td><strong>₹6,875</strong></td>
            </tr>
            <tr>
              <td>Class 11–12 (IIT-JEE Batch)</td>
              <td>₹3,750</td>
              <td>₹5,000</td>
              <td>₹1,250</td>
              <td>₹313</td>
              <td><strong>₹10,313</strong></td>
            </tr>
            <tr>
              <td>Class 11–12 (NEET Batch)</td>
              <td>₹3,750</td>
              <td>₹5,000</td>
              <td>₹1,250</td>
              <td>₹313</td>
              <td><strong>₹10,313</strong></td>
            </tr>
            <tr>
              <td>Class 11–12 (General Batch)</td>
              <td>₹3,750</td>
              <td>₹3,125</td>
              <td>₹938</td>
              <td>₹313</td>
              <td><strong>₹8,125</strong></td>
            </tr>
          </tbody>
        </table>
        <p className={styles.note}>*Transport, hostel, and optional programs are charged separately.*</p>
      </section>

      <section className={styles.section}>
        <h2>What’s Included</h2>
        <ul>
          <li>CBSE syllabus classes</li>
          <li>Competitive exam coaching (IIT-JEE, NEET, CUET, NDA, CA Foundation)</li>
          <li>Printed & digital notes</li>
          <li>Weekly and monthly mock tests</li>
          <li>Lab facilities (Science, Computer)</li>
          <li>Sports, arts, and cultural activities</li>
          <li>Career counseling and mentorship</li>
          <li>Smart classrooms with digital boards</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>Facilities at PrepX Pathshala</h2>
        <ul>
          <li><strong>Smart Classrooms</strong> – Projector-enabled interactive teaching</li>
          <li><strong>Fully Equipped Labs</strong> – Physics, Chemistry, Biology, Computer labs</li>
          <li><strong>Library</strong> – Reference books, competitive prep materials</li>
          <li><strong>Sports Ground</strong> – Cricket, football, indoor games</li>
          <li><strong>Recorded Lectures Access</strong> – For revision anytime</li>
          <li><strong>Parent-Teacher Reports</strong> – Regular performance updates</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>Admission Process</h2>
        <ol>
          <li><strong>Enquiry & Counseling:</strong> Visit our campus or contact online.</li>
          <li><strong>Entrance/Placement Test:</strong> Direct admissions, but for scholorships in fee you need a seprate entrance exam</li>
          <li><strong>Batch Selection:</strong> Choose IIT-JEE, NEET, or General Batch (for Class 11–12).</li>
          <li><strong>Registration & Fee Payment:</strong> First installment to confirm admission.</li>
          <li><strong>Orientation Program:</strong> Students meet teachers, understand schedules, and get materials.</li>
        </ol>
      </section>

      <section className={styles.section}>
        <h2>Why Parents Choose PrepX Pathshala</h2>
        <ul>
          <li>First school in india where teachers are only from IITs/NITs/IIITs and top universities.</li>
          <li>Saves up to 50% compared to paying for separate school and coaching.</li>
          <li>Reduces student stress – no travel between school and coaching.</li>
          <li>Proven competitive results – taught by experienced mentors.</li>
          <li>Affordable monthly payments – easy on family budget.</li>
          <li>Holistic growth – academics, sports, leadership skills.</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>Exclusive Dropper Batch for Competitive Exams</h2>
        <p>
          At PrepX Pathshala, we understand that some students may require additional focused preparation after Class 12 to secure their dream scores in competitive exams like IIT-JEE and NEET. To support this, we offer a dedicated <strong>Dropper Batch</strong> right within our school premises.
        </p>

        <h3>What is the Dropper Batch?</h3>
        <ul>
          <li>A specialized program for students who want to dedicate an extra year for thorough revision and practice.</li>
          <li>Ensures students do not need to seek coaching elsewhere.</li>
          <li>Continuity with the best IIT/NIT experienced faculty ensures top-quality guidance.</li>
        </ul>

        <h3>Key Features</h3>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Feature</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Expert Faculty</td>
              <td>Taught exclusively by IIT/NIT alumni and leading coaching experts.</td>
            </tr>
            <tr>
              <td>Comprehensive Coverage</td>
              <td>Complete syllabus revision with advanced problem-solving for IIT-JEE & NEET.</td>
            </tr>
            <tr>
              <td>Personalized Attention</td>
              <td>Small batch sizes allow individual doubt clearing and mentorship.</td>
            </tr>
            <tr>
              <td>Regular Mock Tests</td>
              <td>Weekly full-length mocks with detailed performance analysis.</td>
            </tr>
            <tr>
              <td>Flexible Timings</td>
              <td>Designed to fit students’ study routines and maximize efficiency.</td>
            </tr>
            <tr>
              <td>Affordable Fee</td>
              <td>Entire Dropper Batch at just <strong>₹30,000 INR per year</strong>.</td>
            </tr>
          </tbody>
        </table>

        <h3>Why Choose the Dropper Batch at PrepX Pathshala?</h3>
        <ul>
          <li>Seamless continuation with trusted faculty and environment.</li>
          <li>Cost-effective premium coaching at a fraction of typical dropper fees.</li>
          <li>Complete support with no hidden costs or extra materials.</li>
        </ul>
      </section>

      <footer className={styles.footer}>
        <p><strong>Contact Us</strong></p>
        <p>Campus Location: Delhi</p>
        <p>Phone: +91-XXXXXXXXXX</p>
        <p>Email: <a href="mailto:support@prepxpathshala.live">support@prepxpathshala.live</a></p>
        <p>Website: <a href="https://www.prepxpathshala.live" target="_blank" rel="noreferrer">www.prepxpathshala.live</a></p>
      </footer>
    </div>
  );
};

export default SchoolHomePage;
